import { inject, Injectable } from '@angular/core';
import { HsBlazorService } from '@hsetu/core-services';

@Injectable({
  providedIn: 'root',
})
export class DataMigrationService {
  private readonly _serviceKey = 'kfmDataMigration';
  private readonly _blazorService = inject(HsBlazorService);

  public async migrateData(): Promise<boolean> {
    const migrationResult = await this._blazorService.invokeService(
      this._serviceKey,
      'MigrateData',
      {},
    );

    if (migrationResult) {
      return !!(migrationResult as Record<string, unknown>)['result'];
    }

    return false;
  }
}
